import { Feature } from 'types';

import { VIEWER_ROLES, REQUIRED_FEATURE } from './definitions';

// ACCOUNTING OVERVIEW (plan §5): who opens the page and what each viewer
// sees on it. Ops answers 403 to everyone else as well.

type Features = readonly string[] | null | undefined;

/** Company Owner, Accounting, Administrative, with the Accounting feature. */
export const isOverviewViewer = (role?: string | null, features?: Features) =>
  Boolean(
    role && VIEWER_ROLES.includes(role) && features?.includes(REQUIRED_FEATURE)
  );

/** The Payout Schedule card is payroll's (Q2 a): payroll's own gate, the
 * role's `payroll` tick (owner 2 Nov 2026; Ops' canViewPayroll). */
export const canViewPayrollCard = (features?: Features) =>
  Boolean(features?.includes(Feature.PAYROLL));

/** The QuickBooks pill and the iPhone "More" row, as today. */
export const hasQuickBooks = (features?: Features) =>
  Boolean(features?.includes(Feature.QUICKBOOKS));
